export default __webpack_public_path__ + "static/media/arrow-right-up-line-white.94f9c0e5.svg";